module.exports = __webpack_public_path__ + "img/xin-c.0ef6e005.png";